// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import CheckoutReviewAndSubmitState from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitState";
import CheckoutReviewAndSubmitStateExtension from "@store/Extensions/Store/Pages/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitState";
import { ExtendState } from "@toolkit/Framework/Types/ReduxActions";
import { Draft } from "immer";

const initialState: ExtendState<CheckoutReviewAndSubmitState, CheckoutReviewAndSubmitStateExtension> = {
    showShippingFormErrors: false,
};

const actions = {
    "Store/Pages/CheckoutReviewAndSubmit/SetValidateShippingDates": (
        draft: Draft<CheckoutReviewAndSubmitState>,
        action: {
            validateRequestedDeliveryDate?: () => boolean;
            validateRequestedPickUpDate?: () => boolean;
            focusRequestedDeliveryDate?: () => void;
            focusRequestedPickUpDate?: () => void;
        },
    ) => {
        draft.validateRequestedDeliveryDate = action.validateRequestedDeliveryDate;
        draft.validateRequestedPickUpDate = action.validateRequestedPickUpDate;
        draft.focusRequestedDeliveryDate = action.focusRequestedDeliveryDate;
        draft.focusRequestedPickUpDate = action.focusRequestedPickUpDate;
    },
    "Store/Pages/CheckoutReviewAndSubmit/SetShowShippingFormErrors": (
        draft: Draft<CheckoutReviewAndSubmitState>,
        action: { showShippingFormErrors: boolean },
    ) => {
        draft.showShippingFormErrors = action.showShippingFormErrors;
    },
};

const reducer = createTypedReducerWithImmer(initialState as CheckoutReviewAndSubmitState, actions);
export type CheckoutReviewAndSubmitActions = Parameters<typeof reducer>[1];
export default reducer;
